import datafeedService from '@/stores/dataManager/apiServices/datafeedService'
import * as interfaceSymbol from '@/stores/dataStore/reduxStore/symbol/interfaceSymbol'
import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { reduxVariableStatus } from '@/stores/dataStore/memoryStore/const/constIndex'
import { convertData } from '@/stores/transformData/transformData'
// import CommonUtils from '@/utilities/utils'
import { findIndex, forEach } from 'lodash'
import { mergeArrayByKey } from '@npm_dev/fss-utilities'

type SymbolState = {
    // symbolsList: any,
    symbolsList: Record<interfaceSymbol.ISymbolsList['KEY'], interfaceSymbol.ISymbolsList> | [],
    symbolsListStatus: string,
    instrumentsStatic: interfaceSymbol.IInstrumentsStatic[] | [],
    instrumentsStaticStatus: string,
    instrumentsDynamic: interfaceSymbol.IInstrumentsStatic[] | [],
    instrumentsDynamicStatus: string,
    symbolsGroup: interfaceSymbol.ISymbolsGroup[] | [],
    symbolsGroupStatus: string,

    instrumentsDynamicDict: any
    symbolsDynamicIsReady: boolean,
}
/**
  * symbolsList: Danh sách mã chứng khoán toàn thị trường 
  * 
*/

export const getSymbolsList = createAsyncThunk(
    'symbols/getSymbolsList',
    async () => {
        try {
            let params = {}
            const response: any = await datafeedService.getSymbolInfo(params)
            // let data: any = convertData.parseSymbolsList(response)
            // console.log('getSymbolsList', response)
            let symbolsList = convertData.parseSymbolsList(response)
            let data: any = {
                symbolsList: symbolsList,
                symbolsGroup: convertData.parsesymbolsGroup(symbolsList)
            }
            // console.log("getSymbolsList.:", data)
            return data
            // return response as Record<interfaceSymbol.ISymbolsList['KEY'], interfaceSymbol.ISymbolsList>
        } catch (error) {
            // console.log(error)
        }
        return null
    },
)

export const getInstrumentsByExchange = createAsyncThunk(
    'symbols/getInstrumentsByExchange',
    async (params: any) => {
        try {
            // console.log("getInstruments.:", params)
            const response: any = await datafeedService.getInstrumentsByExchange(params)
            let data: any = {
                instrumentsStatic: convertData.parseInstrumentsStatic(response),
                instrumentsDynamic: convertData.parseInstrumentsDynamic(response),
            }
            // console.log('getInstrumentsByExchange', response)
            return data
        } catch (error) {
            // console.log(error)
        }
        return null
    },
)

export const getInstrumentsBySymbols = createAsyncThunk(
    'symbols/getInstrumentsBySymbols',
    async (params: any) => {
        try {
            const response: any = await datafeedService.getInstrumentsBySymbols(params)
            return response
        } catch (error) {
        }
        return null
    },
)

const parseObj = (array: any[] | [] | undefined) => {
    if (array === undefined) {
        return { instruments: {}, }
    }
    const result = {
        instruments: <any>{},
    }
    const listExchange: string[] = []
    for (let index = 0; index < array.length; index++) {
        const element: any = parseProto(array[index]);
        result.instruments[element.SB] = element
        if (listExchange.indexOf(element.EX) === -1) {
            listExchange.push(element.EX)
        }
    }
    return result;
}

const parseProto = (rawInstrument: any) => {
    const stockProto = <any>{}
    // id for key of ag grid
    stockProto.id = rawInstrument.symbol
    stockProto.Id = rawInstrument.StockId
    stockProto.SB = rawInstrument.symbol
    stockProto.SI = rawInstrument.StockId
    stockProto.FN = rawInstrument.FullName
    stockProto.TD = rawInstrument.tradingdate
    stockProto.FC = rawInstrument.FloorCode
    stockProto.ST = rawInstrument.StockType
    stockProto.CL = rawInstrument.ceiling
    stockProto.FL = rawInstrument.FloorCode
    stockProto.RE = rawInstrument.reference
    stockProto.B3 = rawInstrument.bidPrice3
    stockProto.V3 = rawInstrument.bidVol3
    stockProto.B2 = rawInstrument.bidPrice2
    stockProto.V2 = rawInstrument.bidVol2
    stockProto.B1 = rawInstrument.bidPrice1 === undefined ? rawInstrument.bidPrice1 : isNaN(Number.parseFloat(rawInstrument.bidPrice1.toString())) ? rawInstrument.bidPrice1.toString() : Number.parseFloat(rawInstrument.bidPrice1.toString())
    stockProto.V1 = rawInstrument.bidVol1
    stockProto.CP = rawInstrument.closePrice
    stockProto.CV = rawInstrument.closeVol
    stockProto.CH = rawInstrument.change
    stockProto.S1 = rawInstrument.offerPrice1 === undefined ? rawInstrument.offerPrice1 : isNaN(Number.parseFloat(rawInstrument.offerPrice1.toString())) ? rawInstrument.offerPrice1.toString() : Number.parseFloat(rawInstrument.offerPrice1.toString())
    stockProto.U1 = rawInstrument.offerVol1
    stockProto.S2 = rawInstrument.offerPrice2
    stockProto.U2 = rawInstrument.offerVol2
    stockProto.S3 = rawInstrument.offerPrice3
    stockProto.U3 = rawInstrument.offerVol3
    stockProto.TT = rawInstrument.totalTrading
    stockProto.TV = rawInstrument.totalTradingValue
    stockProto.AP = rawInstrument.averagePrice
    stockProto.OP = rawInstrument.open
    stockProto.HI = rawInstrument.high
    stockProto.LO = rawInstrument.low
    stockProto.FB = rawInstrument.foreignBuy
    stockProto.FS = rawInstrument.foreignSell
    stockProto.FR = rawInstrument.foreignRemain
    stockProto.SS = rawInstrument.Status
    stockProto.EX = rawInstrument.exchange
    stockProto.CHP = rawInstrument.changePercent
    stockProto.PMP = rawInstrument.PT_MATCH_PRICE
    stockProto.PTQ = rawInstrument.PT_TOTAL_TRADED_QTTY
    stockProto.PTV = rawInstrument.PT_TOTAL_TRADED_VALUE
    stockProto.TO = rawInstrument.TOTAL_OFFER_QTTY
    stockProto.TB = rawInstrument.TOTAL_BID_QTTY
    stockProto.FT = rawInstrument.FundType

    return stockProto
}

const initialState: SymbolState = {
    symbolsList: [],
    symbolsListStatus: reduxVariableStatus.LOADED,
    instrumentsStatic: [],
    instrumentsStaticStatus: reduxVariableStatus.LOADED,
    instrumentsDynamic: [],
    instrumentsDynamicStatus: reduxVariableStatus.LOADED,
    symbolsGroup: [],
    symbolsGroupStatus: reduxVariableStatus.LOADED,
    // instruments: {},
    // groupsStock: {},
    // symbolsIsReady: false,

    instrumentsDynamicDict: {},
    symbolsDynamicIsReady: false,
}
export const symbolsSlice = createSlice({
    name: 'symbols',
    initialState,
    reducers: {
        updateSymbolsList: (state, action) => {
            state.symbolsList = action.payload?.symbolsList
            state.symbolsListStatus = reduxVariableStatus.LOADED
            state.symbolsGroup = action.payload?.symbolsGroup
            state.symbolsGroupStatus = reduxVariableStatus.LOADED
        },
        // updateInstruments: (action, type) => {
        //     console.log("updateInstruments.:", action, type)
        //     // state.instrumentsStatic = action.payload?.instrumentsStatic
        //     // state.instrumentsStaticStatus = reduxVariableStatus.LOADED
        //     // state.instrumentsDynamic =  action.payload?.instrumentsDynamic
        //     // state.instrumentsDynamicStatus = reduxVariableStatus.LOADED
        // },
        updateInstruments: (state, action: PayloadAction<any[]>) => {
            // console.log("updateInstruments.:redux", action)
            // if (action.payload && action.payload?.length !== 0) {
            //     for (const element of action.payload) {
            //         if (!element?.SB) {
            //             // return
            //         } else {
            //             const { SB, ...rest } = element
            //             state.instrumentsDynamic[element?.SB] = { ...state.instrumentsDynamic[element?.SB], ...rest }
            //             // console.log('ha_check_aaaa', { ...state.instruments[element?.SB], ...rest });
            //         }
            //     }
            // }
            if (action.payload && action.payload.length !== 0) {
                // Instead of mutating the state directly, ensure we handle immutability
                const updatedDynamicInstruments = [...state.instrumentsDynamic];
                forEach(action.payload, (e) => {
                    if (e?.SB) {
                        const { SB, ...rest } = e;
                        // Find the index of the existing instrument, or -1 if not found
                        const index = findIndex(updatedDynamicInstruments, (i) => i.SB === SB);
                        if (index !== -1) {
                            // Merge the existing instrument with the new data
                            updatedDynamicInstruments[index] = {
                                ...updatedDynamicInstruments[index],
                                ...rest,
                                bySocketUpdate: true
                            };
                            // console.log("updateInstruments.:redux 2", action)
                        } else {
                            // If not found, add it as a new entry
                            updatedDynamicInstruments.push({ SB, ...rest, bySocketUpdate: true });
                            // console.log("updateInstruments.:redux 333333333333333", action)

                        }
                    }
                });
                // Return the updated array to the state
                state.instrumentsDynamic = updatedDynamicInstruments;
            }
        },

        updateInstrumentsDict: (state, action: PayloadAction<any[]>) => {
            if (action.payload && action.payload.length !== 0) {
                for (const element of action.payload) {
                    if (!element?.SB) {
                        // return
                    } else {
                        const { SB, EX, ...rest } = element
                        const arrayChange = Object.keys(rest) ?? []
                        state.instrumentsDynamicDict[element?.SB] = { ...state.instrumentsDynamicDict[element?.SB], ...rest, keysChange: arrayChange }
                    }
                }
            }
        },

    },
    extraReducers(builder) {
        // builder.addMatcher(getSymbolsList.pending, (state) => {
        //     // console.log('pending')
        //     state.symbolsList = []
        // })
        builder.addCase(getSymbolsList.pending, (state) => {
            // state.symbolsList = []
            state.symbolsListStatus = reduxVariableStatus.PENDING
            // state.symbolsGroup = []
            state.symbolsGroupStatus = reduxVariableStatus.PENDING
        })
        builder.addCase(getSymbolsList.fulfilled, (state, action) => {
            state.symbolsList = action.payload?.symbolsList
            state.symbolsListStatus = reduxVariableStatus.LOADED
            state.symbolsGroup = action.payload?.symbolsGroup
            state.symbolsGroupStatus = reduxVariableStatus.LOADED
            // console.log("getSymbolsList.fulfilled.:", { symbolsList: state.symbolsList, symbolsGroup: state.symbolsGroup })
        })
        builder.addCase(getSymbolsList.rejected, (state) => {
            // state.symbolsList = []
            state.symbolsListStatus = reduxVariableStatus.PENDING
            // state.symbolsGroup = []
            state.symbolsGroupStatus = reduxVariableStatus.FAILED
        })
        /**
         * 
         */
        builder.addCase(getInstrumentsByExchange.pending, (state) => {
            // console.log('pending')
            // state.instrumentsStatic = []
            state.instrumentsStaticStatus = reduxVariableStatus.PENDING
            // state.instrumentsDynamic = []
            state.instrumentsDynamicStatus = reduxVariableStatus.PENDING
        })
        builder.addCase(getInstrumentsByExchange.fulfilled, (state, action) => {
            // console.log('fulfilled')
            state.instrumentsStatic = mergeArrayByKey(state.instrumentsStatic, action.payload?.instrumentsStatic, 'KEY')
            state.instrumentsStaticStatus = reduxVariableStatus.LOADED
            state.instrumentsDynamic = mergeArrayByKey(state.instrumentsDynamic, action.payload?.instrumentsDynamic, 'KEY')
            state.instrumentsDynamicStatus = reduxVariableStatus.LOADED
            // console.log("getInstruments.fulfilled.:", { instrumentsStatic: state.instrumentsStatic, instrumentsDynamic: state.instrumentsDynamic })
        })
        builder.addCase(getInstrumentsByExchange.rejected, (state) => {
            // console.log('rejected')
            state.instrumentsStatic = []
            state.instrumentsStaticStatus = reduxVariableStatus.FAILED
            state.instrumentsDynamic = []
            state.instrumentsDynamicStatus = reduxVariableStatus.FAILED
        })
        /**
         * 
         */
        builder.addCase(getInstrumentsBySymbols.fulfilled, (state, action) => {
            const { instruments } = parseObj(action.payload)
            state.instrumentsDynamicDict = instruments
            state.symbolsDynamicIsReady = true
        })
        builder.addCase(getInstrumentsBySymbols.rejected, (state) => {
            state.instrumentsDynamicDict = {}
        })
    },
})

// Action creators are generated for each case reducer function
export const { updateInstruments, updateInstrumentsDict } = symbolsSlice.actions

export default symbolsSlice.reducer